import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=f255b54c&scoped=true&"
import script from "./Player.vue?vue&type=script&lang=js&"
export * from "./Player.vue?vue&type=script&lang=js&"
import style0 from "./Player.vue?vue&type=style&index=0&id=f255b54c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f255b54c",
  null
  
)

export default component.exports